<template>
  <div class="pt-3">

    <header class="form-legend pl-6 pr-6">
      <h1 class="font-size-h3 c-gray bb-1 pb-1">{{ $content.subscription }}</h1>
    </header>

    <transition name="fade" mode="out-in">
      <div v-if="!discountPlanSelected">
        <div class="row">
          <div class="card highlighted">
            <header class="card-header">
              <h2 class="font-marat t-center two-lines">{{ $content.paper_plan }}</h2>
            </header>

            <div class="card-cover">
              <img src="@/assets/images/paper_plan.png" :alt="$content.paper_plan" />
            </div>

            <div class="card-body">
              <div class="col-sm bb-1 mb-3">
                <div class="mb-3">
                  <label class="label c-gray mb-1" for="paperPlan">{{ $content.subscription_type }}</label>
                  <v-select
                    v-model="paperPlanSelected"
                    @input="resetCountry"
                    id="paperPlan"
                    label="title"
                    :searchable="false"
                    :options="$paperPlans.subscription_plans"></v-select>
                </div>

                <div v-if="paperPlanSelected" class="mb-3">
                  <label class="label c-gray mb-1" for="paperPlanCountry">{{ $content.delivery_country}}</label>
                  <v-select
                    v-model="paperPlanCountry"
                    id="paperPlanCountry"
                    :disabled="!paperPlanSelected.is_abroad"
                    :options="$store.state.countriesArr"></v-select>
                </div>
              </div>

              <div class="col-sm">
                <transition name="fade" mode="in-out">
                  <div v-if="paperPlanSelected">
                    <p>{{ $content.price }}:</p>
                    <p v-if="paperPlanSelected.post_type === 'subscription_chain'" class="text-big c-black t-bold mb-0">
                        {{ paperPlanSelected.price_desc }}
                    </p>
                    <p v-else class="text-big c-black t-bold mb-0">{{ paperPlanSelected.per_month | toPrice }} {{ $content.per_month }}</p>

                    <p v-if="paperPlanSelected.price_desc_2 !== ''" class="c-gray">{{ paperPlanSelected.price_desc_2 }}</p>

                    <div class="c-gray">
                      <p v-if="paperPlanSelected.post_type === 'subscription_chain'">
                          <span class="c-black">{{ paperPlanSelected.price_info }}</span>
                        <br/>{{ $content.mit_renewing_info }}
                      </p>
                      <p v-else-if="paperPlanSelected.is_cyclical !== ''">{{ $content.paid_cyclical }}</p>
                      <p v-else>({{ paperPlanSelected.price | toPrice }} {{ $content.paid_once }})</p>
                    </div>
                  </div>
                </transition>

                <button
                  @click="purchasePlan('paper', false)"
                  :disabled="!paperPlanSelected"
                  class="btn btn-primary btn-max mb-2 mt-2"
                >{{ $content.buy }}</button>
                <button
                  v-if="paperPlanSelected"
                  :disabled="!paperPlanSelected.coupon_link"
                  @click="purchasePlan('paper', true)"
                  class="btn btn-outline-primary btn-max"
                >{{ $content.buy_as_gift }}</button>

              </div>
            </div>

            <div class="card-footer c-bg-white pt-5 pb-5 pl-4 pr-4">
              <div class="col-md">
                <div
                  class="plan-description font-size-h6"
                  v-html="$paperPlans.vue_description">
                </div>
              </div>
            </div>

          </div>

          <div class="card">
            <header class="card-header">
              <h2 class="font-marat t-center two-lines">{{ $content.digital_plan }}</h2>
            </header>
            <div class="card-cover">
              <img src="@/assets/images/digital_plan.png" :alt="$content.digital_plan" />
            </div>

            <div class="card-body">
              <div class="col-sm bb-1 mb-3">
                <div class="mb-3">
                  <label class="label c-gray mb-1" for="digitalPlan">{{ $content.access_type }}</label>
                  <v-select
                    v-model="digitalPlanSelected"
                    id="digitalPlan"
                    label="title"
                    :searchable="false"
                    :options="$digitalPlans.subscription_plans"></v-select>
                </div>
              </div>

              <div class="col-sm">
                <transition name="fade" mode="in-out">
                  <div v-if="digitalPlanSelected">
                    <p>{{ $content.price }}:</p>
                    <p v-if="digitalPlanSelected.post_type === 'subscription_chain'" class="text-big c-black t-bold mb-0">
                        {{ digitalPlanSelected.price_desc }}
                    </p>
                    <p v-else class="text-big c-black t-bold mb-0">{{ digitalPlanSelected.per_month | toPrice }} {{$content.per_month}}</p>

                    <p v-if="digitalPlanSelected.price_desc_2 !== ''" class="c-gray">{{ digitalPlanSelected.price_desc_2 }}</p>

                    <div class="c-gray">
                      <p v-if="digitalPlanSelected.post_type === 'subscription_chain'">
                          <span class="c-black">{{ digitalPlanSelected.price_info }}</span>
                          <br/>{{ $content.mit_renewing_info }}
                      </p>
                      <p v-else-if="digitalPlanSelected.is_cyclical !== ''">{{ $content.paid_cyclical }}</p>
                      <p v-else>({{ digitalPlanSelected.price | toPrice }} {{ $content.paid_once }})</p>
                    </div>
                  </div>
                </transition>
                <button
                  @click="purchasePlan('digital', false)"
                  :disabled="!digitalPlanSelected"
                  class="btn btn-primary btn-max mb-2 mt-2"
                >{{ $content.buy }}</button>
                <button
                  v-if="digitalPlanSelected"
                  @click="purchasePlan('digital', true)"
                  :disabled="!digitalPlanSelected.coupon_link"
                  class="btn btn-outline-primary btn-max"
                >{{ $content.buy_as_gift }}</button>
              </div>
            </div>

            <div class="card-footer c-bg-white pt-5 pb-5 pl-4 pr-4">
              <div class="col-md">
                <div
                  class="plan-description font-size-h6"
                  v-html="$digitalPlans.vue_description">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="this.$appInfo.loyalty" class="row">
            <div class="card">
                <div class="share-it share-it-container">
                    <div class="block block__image">
                        <img :src="this.$appInfo.loyalty.icon_url" alt=""/>
                    </div>
                    <div class="block block__text">
                        <h4 class="title">{{ this.$appInfo.loyalty.title }}</h4>

                        <div class="share-it-text">
                            {{ this.$appInfo.loyalty.text }}
                            <div class="share-it-response" :data-message="newMemberMessage"></div>
                        </div>
                        <div class="share-it-code">
                            <small>{{ $content.sharing_your_code }} </small>
                            <span class="number">{{ this.$appInfo.loyalty.sharing_user_code }}</span>
                        </div>
                        <p class="email-section">
                            <input type="email" name="new-member-email" v-model="newMemberEmail"
                                   placeholder="wpisz adres e-mail"
                                   class="share-it-email form-control"/>
                            <button :title="$content.send_your_code"
                            @click="sendSharingCode()"
                            class="share-it-submit"></button>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
          <div class="card" >
            <header class="card-header">
              <h2 class="font-marat t-center two-lines">{{ $content.coupon_header }}</h2>
            </header>
            <div class="card-image mb-4">
              <img src="@/assets/images/coupon.png" alt="" />
            </div>

            <div class="card-body">
              <div class="col-sm mb-3">
                <div class="mb-3">
                  <label for="discountCode" class="label c-gray mb-1">{{ $content.coupon_code}}:</label>
                  <input id="discountCode" class="form-control" v-model="couponCode" type="text">
                  <p v-show="couponError" class="form-error">{{ $content.coupon_error }}</p>
                </div>
                <button
                  @click="checkCoupon"
                  class="btn btn-outline-primary btn-max"
                >{{ $content.submit }}</button>
              </div>
            </div>
          </div>

          <div class="card" v-if="$appInfo.init.show_coupon_block" :class="{ 'highlighted': $specialPlans.is_highlighted }">
            <header class="card-header">
              <h2 class="font-marat t-center two-lines">{{ $specialPlans.name }}</h2>
            </header>

            <div class="card-image mb-4">
              <img
                src="@/assets/images/special_edition.png"
                alt="Wydanie Specjalne wokół książek" />
            </div>

            <div class="card-body">
              <div class="col-sm mb-3">
                <div class="mb-3">
                  <h3 class="font-size-lg t-uppercase mb-1">{{ specialPlan.title }}</h3>
                  <p class="c-gray mb-2">{{ specialPlan.short_description }}</p>
                  <p class="text-big c-black t-bold mb-0">{{ specialPlan.per_month | toPrice }} zł</p>
                </div>
                <button
                  @click="purchaseSpecial"
                  class="btn btn-primary btn-max"
                >{{ $content.buy }}</button>
              </div>
            </div>
          </div>

        </div>

        <SubscriptionFAQ class="ml-a mr-a"/>
      </div>

      <div v-else>

        <div class="row">
          <div class="card">
            <header class="card-header">
              <h2 class="font-marat t-center two-lines">{{ discountPlanSelected.excerpt }}</h2>
              <button class="back-btn" @click="resetCoupon" title="wróć">
                <img src="@/assets/images/left-chevron.svg" alt="wróć"/>
              </button>
            </header>

            <div class="card-cover">
              <img v-if="discountPlanSelected.is_paper_version" src="@/assets/images/paper_plan.png" :alt="$content.paper_plan" />
              <img v-else src="@/assets/images/digital_plan.png" :alt="$content.digital_plan" />
            </div>

            <div class="card-body">
              <div class="col-sm bb-1 mb-3">
                <div class="mb-3">
                  <label class="label c-gray mb-1" for="couponPlan">{{ $content.subscription_type }}</label>
                  <input class="form-control" id="couponPlan" disabled type="text" :value="discountPlanSelected.excerpt" />
                </div>
              </div>
              <div class="col-sm">
                <p>{{ $content.price }}:</p>
                <p v-if="discountPlanSelected.post_type === 'subscription_chain'" class="text-big c-black t-bold mb-0">
                    {{ discountPlanSelected.price_desc }}
                </p>
                <p v-else class="text-big c-black t-bold mb-0">{{ discountPlanSelected.per_month | toPrice }} {{ $content.per_month}}</p>

                <p v-if="discountPlanSelected.price_desc_2 !== ''" class="c-gray">{{ discountPlanSelected.price_desc_2 }}</p>

                <div v-if="discountPlanSelected.plan_chain instanceof Array" class="c-gray">
                  <p>{{ $content.mit_renewing_info }}</p>
                </div>
                <div v-else class="c-gray">
                  <p v-if="discountPlanSelected.post_type === 'subscription_chain'">
                    <span class="c-black">{{ discountPlanSelected.price_info }}</span>
                    <br/>{{ $content.mit_renewing_info }}
                  </p>
                  <p v-else-if="discountPlanSelected.is_cyclical">{{ $content.paid_cyclical }}</p>
                  <p v-else>({{ discountPlanSelected.price | toPrice }} {{ $content.paid_once }})</p>
                </div>

                <button
                  @click="purchaseDiscountPlan"
                  class="btn btn-primary btn-max mb-2 mt-2"
                >{{ $content.buy }}</button>
              </div>
            </div>

            <div class="c-bg-white pt-5 pb-5 pl-4 pr-4">
              <div class="col-md">
                <template v-if="discountPlanSelected.is_paper_version">

                </template>
                <div
                  v-if="discountPlanSelected.is_paper_version"
                  v-html="$paperPlans.vue_description"
                  class="plan-description font-size-h6"
                >
                </div>
                <div
                  v-else
                  v-html="$digitalPlans.vue_description"
                  class="plan-description font-size-h6"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </transition>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SubscriptionFAQ from './SubscriptionFAQ';
  import filtersMixin from '../../mixins/filters.js';
  const DEFAULT_COUNTRY = 'Polska';

  export default {
    components: { SubscriptionFAQ },
    mixins: [ filtersMixin ],
    beforeCreate() {
    },
    data() {
      return {
        specialPlan: this.$specialPlans.subscription_plans[0],
        digitalPlanSelected: this.$digitalPlans.subscription_plans[0],
        paperPlanSelected: this.$paperPlans.subscription_plans[0],
        discountPlanSelected: '',
        paperPlanCountry: DEFAULT_COUNTRY,
        abroadCountry: '',
        newMemberEmail: '',
        newMemberMessage: '',
        couponError: false,
        request_processing: false,
      }
    },
    computed: {
      couponCode: {
        get () {
          return this.$store.state.couponCode
        },
        set (value) {
          this.$store.commit('setCouponCode', { code: value })
        }
      },
      ...mapGetters({
        selectedPlan: 'GET_SELECTED_PLAN',
      })
    },
    methods: {
      sendSharingCode() {

        if (this.newMemberEmail.match(/^[\w.]+@([a-zA-Z_]+?\.)+[a-zA-Z]{2,3}$/) == null) {
            this.newMemberMessage = this.$content.check_email;
            return;
        }

        if (this.request_processing) {
            return;
        }

        this.request_processing = true;
        this.newMemberMessage = this.$content.sending;

        let formData = new FormData();
        formData.append('recipient_email', this.newMemberEmail);
        let vm = this;
        this.$http.post('/wp-admin/admin-ajax.php?action=send_sharing_code', formData)
          .then(response => {
            vm.newMemberMessage = response.data.data.message;
            vm.request_processing = false;
          });
      },
      checkCoupon() {
        let formData = new FormData();
        formData.append('coupon_code', this.couponCode);
        this.$http.post('/wp-admin/admin-ajax.php?action=check_coupon', formData)
          .then(response => {
            let couponData = response.data.coupon_plan;

            if (!couponData.ID) {
              this.couponError = true;
              return false;
            }
            this.couponError = false;

            if (
              couponData.kind_of_coupon === 'user-coupon' ||
              (couponData.per_month === 0 && couponData.price === '0.00')
            ) {
              this.$store.commit('setCouponCode', { code: this.couponCode });
              this.$store.commit('setActiveStep', { activeStep: 'GiftForm' });
            } else {
              setTimeout( () => {
                this.discountPlanSelected = couponData;
              },500);
            }
            window.scrollTo(0,0);
          })
          .catch(err => {
            this.couponError = true;
          });
      },
      resetCountry() {
        this.paperPlanCountry = DEFAULT_COUNTRY
      },
      resetCoupon() {
        this.discountPlanSelected = null;
        sessionStorage.removeItem('couponCode');
      },
      purchasePlan(planType, isGift) {
        if (isGift) {
          this.$store.commit('setGiftStatus', { isGift: true });
        } else {
          this.$store.commit('setGiftStatus', { isGift: false });
        }
        this.$store.commit('saveGiftInSession');

        switch (planType) {
          case 'digital':
            this.$store.commit('setSelectedPlan', { selectedPlan: {
                type: 'digital',
                ...this.digitalPlanSelected
              }
            });
            if (isGift) {
              this.nextStepSkip(false);
            } else {
              this.nextStepSkip(true);
            }
            break;
          case 'paper':
            this.$store.commit('setSelectedPlan', { selectedPlan: {
                type: 'paper',
                ...this.paperPlanSelected,
              }
            });
            this.nextStepSkip(false);
            break;
          default:
            break;
        }
        this.$gtm.trackEvent({
          event: 'subscription selection', // Event type [default = 'interaction'] (Optional)
          category: 'prenumerata',
          action: 'click',
          label: this.selectedPlan.title,
          value: this.selectedPlan.price,
        });
        // eslint-disable-next-line
        fbq('track', 'AddToCart', {
          content_name: this.selectedPlan.title,
          content_category: 'prenumerata',
          content_ids: [ this.selectedPlan.ID ],
          content_type: this.selectedPlan.type,
          value: this.selectedPlan.price,
          currency: 'PLN'
        });
      },
      purchaseDiscountPlan() {
        this.$store.commit('setGiftStatus', {isGift: false });
        this.$store.commit('saveGiftInSession');

        if (this.discountPlanSelected.is_paper_version) {
          this.$store.commit('setSelectedPlan', { selectedPlan: {
              type: 'paper',
              ...this.discountPlanSelected
            }
          });
          this.nextStepSkip(false);
        } else {
          this.$store.commit('setSelectedPlan', { selectedPlan: {
              type: 'digital',
              ...this.discountPlanSelected
            }
          });
          this.nextStepSkip(true);
        }
        // eslint-disable-next-line
        fbq('track', 'AddToCart', {
          content_name: this.selectedPlan.title,
          content_category: 'prenumerata/zniżka',
          content_ids: [ this.selectedPlan.ID ],
          content_type: this.selectedPlan.type,
          value: this.selectedPlan.price,
          currency: 'PLN'
        });
      },
      purchaseSpecial() {
        this.$store.commit('setGiftStatus', {isGift: false});
        this.$store.commit('setSelectedPlan', { selectedPlan: {
            type: 'special',
            ...this.specialPlan,
          }
        });
        this.nextStepSkip( !this.specialPlan.is_shipping );
      },
      nextStepSkip(skipDelivery) {
        if (!this.$store.state.userData.name) {
          this.$store.commit('setActiveStep', { activeStep: 'AuthStep' });
        } else {
          if (skipDelivery) {
            this.$store.commit('setActiveStep', { activeStep: 'SummaryStep' });
          } else {
            this.$store.commit('setActiveStep', { activeStep: 'DeliveryStep' });
          }
        }
      }
    },
    watch: {
      paperPlanCountry(newVal, oldVal) {
        this.$store.commit('setCountry', {deliveryCountry: newVal });
        if (newVal !== DEFAULT_COUNTRY) {
          this.abroadCountry = newVal;
        }
      },
      paperPlanSelected(newVal, oldVal) {
        if (newVal.is_abroad && this.abroadCountry) {
          this.paperPlanCountry = this.abroadCountry;
        } else {
          this.paperPlanCountry = DEFAULT_COUNTRY;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/mixins';
  @import '../../scss/subcard';

  .text-big {
    font-size: var(--font-32);
    font-family: var(--font-marat);
  }

  .col-sm {
    margin-right: auto;
    margin-left: auto;
    max-width: 320px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .col-md {
    margin-right: auto;
    margin-left: auto;
    max-width: 360px;
  }

  .back-btn {
    padding: 0;
    border: none;
    background: transparent;
    top: 30px;
    left: -30px;
    cursor: pointer;
    position: absolute;
    img {
      width: 32px;
      height: 32px;
    }
  }
</style>
